import React, { useEffect, useRef, useState } from "react";
import { useInViewport } from "react-in-viewport";

// Model
import { locations } from "../../model/data";

// Hooks
import useDevice from "../../hooks/useDevice";

// Components
import {
  Divider,
  Grid,
  Card,
  CardActions,
  CardContent,
  Button,
  Typography,
  Zoom,
} from "@mui/material";

const Location = (props) => {
  const contentRef = useRef();
  const [startTransition, setStartTransition] = useState(false);
  const { inViewport } = useInViewport(contentRef);
  const { device } = useDevice();

  useEffect(() => {
    if (inViewport) setStartTransition(true);
  }, [inViewport]);

  return (
    <div {...props} className={`vjc_main-location ${device}`}>
      <Divider style={{ marginTop: '50px' }}>
        <Typography variant="h1" sx={{ fontSize: "26px" }}>
          When & Where
        </Typography>
      </Divider>
      <Grid container spacing={3} ref={contentRef}>
        {[...locations].map(
          ({ title, dateTime, description, address, googleUrl, wazeUrl }, index) => {
            return (
              <Zoom
                in={startTransition}
                timeout={startTransition ? (index + 1) * 1000 : 0}
                key={index}
              >
                <Grid item xs>
                  <Card sx={{ width: "100%" }} elevation={0}>
                    <CardContent sx={{ height: "120px" }}>
                      <Typography gutterBottom variant="h6">
                        {title}
                      </Typography>
                      <Typography className="description" variant="body2" color="text.secondary" style={{ fontWeight: 700, fontSize: '16px', marginBottom: '8px' }}>
                        {description}
                      </Typography>
                      <Typography className="address" variant="body2" color="text.secondary">
                        {address}
                      </Typography>
                      <Typography
                        className="dateTime"
                        variant="body2"
                        color="text.secondary"
                        style={{ fontWeight: 700 }}
                      >
                        {dateTime}
                      </Typography>
                    </CardContent>
                    <CardActions>
                      <Button
                        size="small"
                        onClick={() => {
                          window.open(googleUrl);
                        }}
                      >
                        Google Map
                      </Button>
                      <Button
                        size="small"
                        onClick={() => {
                          window.open(wazeUrl);
                        }}
                      >
                        Waze
                      </Button>
                    </CardActions>
                  </Card>
                </Grid>
              </Zoom>
            );
          }
        )}
      </Grid>
      <iframe
        title="google-map"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3861.082834786843!2d121.13559111157306!3d14.594355577168892!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3397b89b1a72939d%3A0xc624471e18330193!2sEmperor%20Event%20Center!5e0!3m2!1sen!2sph!4v1766765652112!5m2!1sen!2sph"
        width="600"
        height="450"
        style={{ border: 0 }} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
    </div>
  );
};

export default Location;
